import { Badge } from "@/components/common/DataTable";

export function TableWidget({ widget }) {
  const rows = Array.isArray(widget.data) ? widget.data : [];
  return (
    <div className="bg-card rounded-xl border border-border p-5 shadow-sm" data-testid={`widget-${widget.widgetKey}`}>
      <h3 className="font-semibold text-foreground mb-4">{widget.title}</h3>
      <div className="space-y-2.5 max-h-64 overflow-y-auto" data-testid="recent-activity">
        {rows.length === 0 && <p className="text-sm text-muted-foreground">No activity yet</p>}
        {rows.map((a, i) => (
          <div key={i} className="flex items-center justify-between text-sm border-b border-border pb-2">
            <div className="flex items-center gap-2">
              <Badge color="teal">{a.entityType}</Badge>
              <span className="text-muted-foreground">{a.action}</span>
            </div>
            <span className="text-xs text-muted-foreground">
              {(a.timestamp || "").slice(0, 16).replace("T", " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
